import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element: Component, ...rest }) => {
  const isLogged = Boolean(localStorage.getItem('scancamPortalisLogged'));

  return isLogged ? <Component {...rest} /> : <Navigate to="/scancam/" />;
};

export default PrivateRoute;